<div>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>

  <p-dialog [(visible)]="configMissing" [closable]="false" appendTo="self">
    <i style="font-size: 10px" class="pi pi-exclamation-circle pr-1"></i> <label>{{ errorMessage }}</label>
    <br />
    <br />
  </p-dialog>

  <app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

    <form [formGroup]="perforationsForm" novalidate>
      <ng-container formArrayName="perforations">
        <p-table
          class="pr-2"
          [appAutoTableHeight]="true"
          [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
          [appAutoTableHeightOffset]="62"
          (appAutoTableHeightChange)="tableHeight = $event"
          [scrollable]="true"
          [scrollHeight]="tableHeight"
          styleClass="p-datatable-gridlines"
          [columns]="columnDefs"
          [resizableColumns]="true"
          [value]="perforations.controls"
          dataKey="value.id"
          stateStorage="local"
          showGridlines
          [stateKey]="componentId"
          [tableStyle]="{'min-width': '2rem'}"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track $index) {
              <th pResizableColumn>
                {{ col.header }}
              </th>
              }
              <th class="text-center">
                <p-button
                  size="small"
                  class="outlined-button"
                  severity="success"
                  icon="pi pi-plus"
                  outlined="true"
                  [disabled]="configMissing || perforations.invalid"
                  (click)="onAddPerforation()"
                ></p-button>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-perforationFg let-rIdx="rowIndex">
            <ng-container [formGroupName]="rIdx">
              <tr>
                <td>
                  <input style="width: 93%" pInputText formControlName="name"/>
                  <app-validation-error
                    [isValid]="isControlInvalid(perforationFg, 'name')"
                    [errorMsg]="getControlErrors(perforationFg, 'name')"
                  />
                </td>
                <td>
                  <div class="flex items-center">
                    <p-inputNumber
                      formControlName="measuredDepth"
                      [minFractionDigits]="1"
                    ></p-inputNumber>
                    <app-validation-error
                      [isValid]="isControlInvalid(perforationFg, 'measuredDepth')"
                      [errorMsg]="
                        getControlErrors(perforationFg, 'measuredDepth')
                      "
                    />
                  </div>
                </td>
                <td>
                  <p-inputNumber
                    formControlName="temperature"
                    [maxFractionDigits]="2"
                  ></p-inputNumber>
                  <app-validation-error
                    [isValid]="isControlInvalid(perforationFg, 'temperature')"
                    [errorMsg]="getControlErrors(perforationFg, 'temperature')"
                  />
                </td>

                <td class="text-center">
                  <p-button
                    text
                    size="small"
                    severity="danger"
                    title="Delete Perforation"
                    icon="pi pi-trash"
                    (click)="onDeletePerforation(rIdx)"
                  ></p-button>
                </td>
              </tr>
            </ng-container>
          </ng-template>
        </p-table>
      </ng-container>
    </form>
  </app-tool-loader>
</div>
